<template>
  <div v-if="meetingPoint !== null" class="preview__section">
    <div class="preview__title">
      {{ translations.endPointTitle.text }}
    </div>
    <p v-if="!meetingPoint.is_end_point" class="preview__text" v-text="endPoint.address" />
    <br v-if="endPoint != null && endPoint.description && !meetingPoint.is_end_point" />
    <p v-if="endPoint != null && endPoint.description && !meetingPoint.is_end_point" class="preview__text" v-text="endPoint.description" />
    <p v-else-if="meetingPoint.is_end_point" class="preview__text" v-text="translations.textReturns.text" />
  </div>
</template>

<script>
export default {
  name: 'MeetingPoint',
  props: {
    meetingPoint: { type: Object, default: () => {} },
    endPoint: { type: Object, default: () => {} },
    translations: { type: Object, default: () => ({}) }
  }
}
</script>

<style lang="scss"></style>
